import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	externalLinksAddLink: {
		id: 'servicedesk-external-links.links.add-link-modal.external-links-add-link',
		defaultMessage: 'Add link',
		description: 'Header for Add Link modal',
	},
	externalLinksAdd: {
		id: 'servicedesk-external-links.links.add-link-modal.external-links-add',
		defaultMessage: 'Add',
		description: 'Text of the "add" button to add new link',
	},
	externalLinksCancel: {
		id: 'servicedesk-external-links.links.add-link-modal.external-links-cancel',
		defaultMessage: 'Cancel',
		description: 'Text of the "cancel" button to cancel adding a link',
	},
	externalLinkAddSuccessFlagTitle: {
		id: 'servicedesk-external-links.links.add-link-modal.external-link-add-success-flag-title',
		defaultMessage: 'Link added',
		description: 'title text for add link success flag',
	},
	externalLinkAddSuccessFlagDescription: {
		id: 'servicedesk-external-links.links.add-link-modal.external-link-add-success-flag-description',
		defaultMessage: 'The link ‘{linkTitle}’ will now show up in your portal.',
		description: 'description text for add link success flag',
	},
	externalLinkAddFailureTitle: {
		id: 'servicedesk-external-links.links.add-link-modal.external-link-add-failure-title',
		defaultMessage: 'We couldn’t add this link',
		description: 'title text for add link failure flag',
	},
	externalLinkAddFailureDescription: {
		id: 'servicedesk-external-links.links.add-link-modal.external-link-add-failure-description',
		defaultMessage: 'Try again in some time.',
		description: 'ddescription text for add link success flag',
	},
	externalLinksEditLink: {
		id: 'servicedesk-external-links.links.add-link-modal.external-links-edit-link',
		defaultMessage: 'Edit link',
		description: 'Header for Edit Link modal',
	},
	externalLinksSaveLink: {
		id: 'servicedesk-external-links.links.add-link-modal.external-links-save-link',
		defaultMessage: 'Save changes',
		description: 'Text of the "save" button to edit new link',
	},
	externalLinkUpdateSuccessFlagTitle: {
		id: 'servicedesk-external-links.links.add-link-modal.external-link-update-success-flag-title',
		defaultMessage: 'Link updated',
		description: 'title text for update link success flag',
	},
	externalLinkUpdateSuccessFlagDescription: {
		id: 'servicedesk-external-links.links.add-link-modal.external-link-update-success-flag-description',
		defaultMessage:
			'The changes you made to the link ‘{linkTitle}’ will now be visible to customers.',
		description: 'description text for update link success flag',
	},
	linkFlagActionLabel: {
		id: 'servicedesk-external-links.links.add-link-modal.link-flag-action-label',
		defaultMessage: 'View in portal',
		description: 'label text for link flag action',
	},
	externalLinkUpdateFailureTitle: {
		id: 'servicedesk-external-links.links.add-link-modal.external-link-update-failure-title',
		defaultMessage: 'We couldn’t update this link',
		description: 'title text for update link failure flag',
	},
	externalLinkUpdateFailureDescription: {
		id: 'servicedesk-external-links.links.add-link-modal.external-link-update-failure-description',
		defaultMessage: 'Try again in some time.',
		description: 'ddescription text for update link success flag',
	},
});
